export default __webpack_public_path__ + "static/media/notautherized.949a1e24.png";